import React from "react";

function SSLTableElement(props) {
  const expireDate = new Date(props.expiration);
  if (expireDate.toString() === "Invalid Date") {
    return <td className="alert">{props.expiration}</td>;
  }
  const now = new Date();
  const oneMonth = 30 * 24 * 60 * 60 * 1000;
  if (expireDate < now) {
    return <td className="alert">Expired</td>;
  } else if (expireDate - now < oneMonth) {
    return (
      <td className="alert">
        Expires{" "}
        {expireDate.toLocaleDateString(undefined, { dateStyle: "short" })}
      </td>
    );
  } else {
    return <td>OK</td>;
  }
}

export default SSLTableElement;
